import {
  Button,
  CircularProgress,
  CircularProgressLabel,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import VideoLoadingAnimation from "./VideoLoadingAmimation";
let media_recorder = null;
let blobs_recorded = [];

function LiveVideo(props) {
  const [videoCountDown, setVideoCountDown] = useState(10);
  const [countStarted, setCountStarted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [disableBtn, setDisableBtn] = useState(false);

  const cancelRef = useRef();

  const videoRef = useRef();
  let camera_stream = null;

  function blobToFile(theBlob, fileName) {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }

  useEffect(() => {
    if (!props?.openModal?.open) return;

    setTimeout(async () => {
      navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: true,
        })
        .then((stream) => {
          videoRef.current.srcObject = stream;
          setLoading(false);

          document
            .getElementById("start-video")
            .addEventListener("click", async () => {
              setDisableBtn(true);
              // set MIME type of recording as video/webm
              media_recorder = await new MediaRecorder(stream, {
                mimeType: "video/webm",
              });

              media_recorder.start();
              setCountStarted(true);

              // event : new recorded video blob available
              media_recorder.addEventListener("dataavailable", function (e) {
                blobs_recorded.push(e.data);
              });

              // event : recording stopped & all blobs sent
              media_recorder.addEventListener("stop", async function () {
                // create local object URL from the recorded video blobs
                let video_local = URL.createObjectURL(
                  new Blob(blobs_recorded, { type: "video/webm" })
                );

                const blob = new Blob(blobs_recorded, { type: "video/webm" });
                const myFile = blobToFile(blob, "my-video.webm");
                console.log('modalFile: ', myFile);

                setCountStarted(false);
                props?.onFinish(myFile);
              });
            });

          document
            .getElementById("cancel")
            .addEventListener("click", async () => {
               stream.getTracks().forEach((track) => {
                track.stop();
              });

              videoRef.current.srcObject = null;
              props.close();
            });
        });
    }, 3000);
  }, [props?.openModal?.open]);

  useEffect(() => {
    let interval;

    if (!countStarted) return;

    if (parseInt(videoCountDown) < 1) {
      clearInterval(interval);
      media_recorder.stop();
      cancelRef.current.click();

      return;
    }
    interval = setInterval(() => {
      setVideoCountDown(videoCountDown - 1);
    }, 2000);

    return () => clearInterval(interval);
  }, [countStarted, videoCountDown]);

  return (
    <Stack
      position={"relative"}
      justifyContent="center"
      alignItems={"center"}
      py="20px"
      spacing={"20px"}
    >
      {loading && <VideoLoadingAnimation />}

      <video
        ref={videoRef}
        id="video"
        width="520"
        height="340"
        autoPlay
      ></video>
      <Text fontSize={".76em"} textAlign="center">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Odio
        reiciendis distinctio molestias nisi tempora perspiciatis, quam
        consequuntur ut ducimus
      </Text>
      <Stack
        direction={"row"}
        alignItems={"center"}
        spacing="20px"
      >
        <Button
          id="start-video"
          disabled={loading || disableBtn}
          p="20px"
          size={"xs"}
          bg="#00157E"
          _hover={{ background: "#00157E" }}
          color="#fff"
        >
          Start Video
        </Button>

        <Button
          ref={cancelRef}
          disabled={loading}
          id="cancel"
          p="20px"
          size={"xs"}
          border="1px solid #80808030"
          bg="transparent"
          _hover={{ background: "transparent" }}
        >
          Cancel
        </Button>
        <CircularProgress value={videoCountDown * 10} color="green.400">
          <CircularProgressLabel>
            {videoCountDown} <span style={{ fontSize: ".8em" }}>sec</span>
          </CircularProgressLabel>
        </CircularProgress>
      </Stack>
    </Stack>
  );
}

export default LiveVideo;
